
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  getPiCombinedUnit,
  getSupplierProduct,
  putPiCombinedUnit,
} from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";
import { postCancelOrder, getCancelOrderList } from "@/api/purchase-order";

@Component({
  name: "ModifyDiscounts",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "终止订单" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {id: any,code: any};

  public order_show = false;

  @Watch("show", { immediate: true })
  private async watchData() {
    if ((this.selectedItem as any).id && this.show) {
      this.form = deepClone(this.selectedItem);
    }
    console.log('传输过来的数据',this.selectedItem)
  }

  private form = {} as any;
  private all_progress = "";
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "HQ交易号码",
      prop: "hqTransactionNumber",
      key: "hqTransactionNumber",
      show: true,
      disabled: false,
    },
    {
      label: "询价参照号",
      prop: "inquiryRefNumber",
      key: "inquiryRefNumber",
      show: true,
      disabled: false,
    },
    {
      label: "参照号类型",
      prop: "inquiryRefType",
      key: "inquiryRefType",
      show: true,
      disabled: false,
    },
    {
      label: "交货进度",
      prop: "orderQuantity",
      key: "orderQuantity",
      show: true,
      disabled: false,
    },
  ];
  // created() {
  //   this.getList();
  // }

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async submitForm(): Promise<void> {
    this.putPiCombinedUnit();
  }

  private onSelectionChange(rows: any[]) {
    console.log(rows);
  }

  public async handleDelete(scope) {
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
  }

  // 更新组合单位
  private async putPiCombinedUnit() {
    const {
      hqProductName,
      supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit,
    } = this.form;
    let params = {
      hqProductName,
      supplierAbbr: supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit,
    };
    try {
      await putPiCombinedUnit(this.form.id, params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }

  private orderClose() {
    this.order_show = false;
  }

  private async getPiCombinedUnit() {
    const res: any = await getPiCombinedUnit(this.form.id);
    this.getSupplierProduct(res.supplierId);
  }

  private async getSupplierProduct(supplierId) {
    const res: any = await getSupplierProduct(supplierId, {
      hqProductName: this.form.hqProductName,
    });
    this.$set(this.form, "shipmentChineseUnit", res.chineseUnit || "");
    this.$set(this.form, "shipmentEnglishUnit", res.englishUnit || "");
    this.$set(this.form, "shipmentQuantity", 1);
    this.$set(this.form, "deliveryQuantity", 1);
  }

  private async submitpost() {
    this.order_show = false;
    await postCancelOrder(this.selectedItem.id);
    this.$notify({
      title: "成功",
      message: "终止成功",
      type: "success",
      duration: 2000,
    });
    this.close();
  }
  public loading = false;
  public async getList() {
    this.loading = true;
    const res: any = await getCancelOrderList(this.selectedItem.id);
    let all_top = 0;
    let all_down = 0;
    res.map((item) => {
      all_top =
        parseInt(item.declarationPlanQuantity) +
        parseInt(item.goodsEnteredQuantity) +
        all_top;
      all_down = parseInt(item.orderQuantity) + all_down;
    });
    this.all_progress = all_top + "/" + all_down;
    res.map((item) => {
      item.orderQuantity =
        parseInt(item.declarationPlanQuantity) +
        parseInt(item.goodsEnteredQuantity) +
        "/" +
        item.orderQuantity;
    });
    this.table.total = res.length;
    this.table.list = res;
    this.loading = false;
  }
}
